import React from 'react';
import { ReactComponent as DoubleChevronIcon } from 'src/assets/icons/double-chevron.svg';

export const DoubleChevron: React.VFC<{ right?: boolean }> = ({ right }) => (
  <DoubleChevronIcon
    style={right ? { transform: 'rotate(180deg)' } : undefined}
  />
);
